
/**
 * @imports
 */
import DOMInit from '@webqit/browser-pie/src/dom/index.js';
import HTMLPartials from './index.js';

/**
 * @init
 */
HTMLPartials(DOMInit(window));